export function hasReelProductVideo(product) {
  const urls = product && Array.isArray(product.videoUrls) ? product.videoUrls : [];
  if (urls.some((url) => String(url || "").trim())) {
    return true;
  }
  const videoUrl = product && product.videoUrl ? product.videoUrl : "";
  return Boolean(String(videoUrl).trim());
}

export function isReelEligibleProduct(product) {
  return hasReelProductVideo(product);
}

export function filterReelEligibleProducts(products) {
  return (Array.isArray(products) ? products : []).filter(isReelEligibleProduct);
}
